import { createContext, useReducer, useEffect } from "react";
import { useAuthHeader } from '../hooks/useAuthHeader';
import toast from 'react-hot-toast';

export const AuthContext = createContext();

export const authReducer = (state, action) => {
    // eslint-disable-next-line
    const authHeader = useAuthHeader();
    switch (action.type) {
        case 'LOGIN':
            console.log('Logging in user.');
            // Store in localStorage when logging in
            localStorage.setItem('user', JSON.stringify(action.payload));
            return {user: action.payload}
        case 'LOGOUT':
            console.log('Logging Out user');
            // Clear from localStorage when logging out
            localStorage.removeItem('user');
            authHeader.removeAuthHeader();
            return {user: null}
        default:
            return state
    }
}

export const AuthProvider = ({children}) => {
    // Initialize state with user data from localStorage if it exists
    const [state, dispatch] = useReducer(authReducer, {
        user: JSON.parse(localStorage.getItem('user'))
    })

    //console.log('AuthContext State: ', state)

    useEffect(() => {
        const currentPath = window.location.pathname;
        const isAuthPage = currentPath === '/login' || currentPath === '/signup';

        // Check if we have a stored user but no state
        const storedUser = localStorage.getItem('user');
        if (storedUser && !state.user) {
            dispatch({ type: 'LOGIN', payload: JSON.parse(storedUser) });
        }
        // Only show expired message if no stored user and not on auth pages
        else if (!storedUser && !isAuthPage) {
            console.log('No user found in state, logging out');
            toast.error('Session expired. Please login again.');
            dispatch({ type: 'LOGOUT' });
            window.location = '/login';
        }
    }, [state.user]);

    return (
        <AuthContext.Provider value={{...state, dispatch}}>
            { children }
        </AuthContext.Provider>
    )
}